export const TaskKeys = {
	all: ["tasks"] as const,
	list: () => [...TaskKeys.all, "list"] as const,
	detail: (id: number) => [...TaskKeys.all, "detail", id] as const,
	workflows: (id: number) => [...TaskKeys.all, "workflows", id] as const,
};
